// docsTags id see http://localhost:3000/api-docs/#/ClientDocument/post_api_clientdocuments
const docsTags = [
  {id: 1, name: '#PoA', type: 'tag'},
  {id: 2, name: '#Lease', type: 'tag'},
  {id: 3, name: '#Certificate of Good Standing', type: 'tag'},
  {id: 4, name: '#Certificate of Incorporation', type: 'tag'},
  {id: 5, name: '#Certificate of Incumbency', type: 'tag'},
  {id: 6, name: '#Extract', type: 'tag'},
  {id: 7, name: '#Office Lease Agreement', type: 'tag'},
  {id: 8, name: '#Apt Lease Agreement', type: 'tag'},
  {id: 9, name: '#EJARI', type: 'tag'},
  {id: 10, name: '#MOA', type: 'tag'},
  {id: 11, name: '#Share Certificate', type: 'tag'},
  {id: 12, name: '#License', type: 'tag'},
  {id: 13, name: '#Passport', type: 'tag'},
  {id: 14, name: '#Emirates ID', type: 'tag'},
  {id: 15, name: '#Statement', type: 'tag'},
  {id: 16, name: '#Tokens', type: 'tag'},
  {id: 17, name: '#Card', type: 'tag'},
  {id: 18, name: '#Board Resolution', type: 'tag'},
  {id: 19, name: '#Letter', type: 'tag'},
  {id: 20, name: '#Certificate', type: 'tag'},
  {id: 21, name: '#Misc', type: 'tag'}
]

const docsOwnTags = [
  {id: 1, name: '#Personal', type: 'own'},
  {id: 2, name: '#Corporate', type: 'own', popup: true}
]

const docLocation = {
  client: 1,
  office: 2
}

export {docsTags, docsOwnTags, docLocation}



// WEBPACK FOOTER //
// ./src/constants/documentTags.js